// extracted by mini-css-extract-plugin
export default {"melodyVideo":"KN-z","isFullWidth":"LN-z","landingPageVideo":"MN-z","play":"NN-z","iframeVideo":"ON-z","playHidden":"PN-z","fullwidth":"QN-z"};